import {Component, Type} from '@wonderlandengine/api';

export class MobileActiveSwitch extends Component {
    static TypeName = 'mobile-active-switch';
    static Properties = {
        affectChildren: {type: Type.Bool, default: true},
    };

    start() {
        this.components = [];
        this.getComponents(this.object);
        if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
            this.setComponentsActive(true);
            console.log(this.components);
        }

        window.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    }

    getComponents(obj) {
        const comps = obj.getComponents().filter((c) => c.type != 'mobile-active-switch');
        this.components = this.components.concat(comps);

        if (this.affectChildren) {
            let children = obj.children;
            for (let i = 0; i < children.length; ++i) {
                this.getComponents(children[i]);
            }
        }
    }

    setComponentsActive(active) {
        const comps = this.components;
        for (let i = 0; i < comps.length; ++i) {
            comps[i].active = active;
        }
    }
}
